var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReleaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.18135V0.482937C10 0.21627 9.78376 0 9.51709 0H6.81868C6.55162 0 6.33495 0.216667 6.33495 0.48373V0.785714C6.33495 1.05278 6.55162 1.26944 6.81868 1.26944H7.629C7.704 1.26944 7.7417 1.36032 7.68852 1.41349L4.70558 4.39643C4.52066 4.58135 4.52066 4.88135 4.70558 5.06627L4.93336 5.29405C5.11828 5.47897 5.41828 5.47897 5.6032 5.29405L8.58614 2.31111C8.63931 2.25794 8.73019 2.29563 8.73019 2.37064V3.18095C8.73019 3.44802 8.94685 3.66468 9.21392 3.66468H9.5159C9.78297 3.66468 9.99963 3.44802 9.99963 3.18095L10 3.18135Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73016 5.83178V8.25519C8.73016 8.51749 8.51746 8.72979 8.25556 8.72979H1.74444C1.48214 8.72979 1.26984 8.51709 1.26984 8.25519V1.74448C1.26984 1.48217 1.48254 1.26987 1.74444 1.26987H4.525C4.7873 1.26987 4.9996 1.05717 4.9996 0.795269V0.475031C4.9996 0.212729 4.7869 0.00042757 4.525 0.00042757H0.812698C0.363889 3.07449e-05 0 0.36392 0 0.812729V9.18733C0 9.63614 0.363889 10 0.812698 10H9.1873C9.63611 10 10 9.63614 10 9.18733V5.83178C10 5.56948 9.7873 5.35717 9.5254 5.35717H9.20516C8.94286 5.35717 8.73056 5.56987 8.73056 5.83178H8.73016Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseIcon);
export default __webpack_public_path__ + "static/media/ReleaseIcon.9e5f572d0e1dd4eab12745795825faff.svg";
export { ForwardRef as ReactComponent };